<template>
  <div>
    <v-chip small label :ripple="false" color="var(--v-resRed-darken1)" text-color="white">
      EXP
    </v-chip>
  </div>
</template>

<script>
  export default {
    name: 'LeaseExpiresReadonlyCell',
  }
</script>

<style scoped lang="scss">
</style>
